/* ****************************************************************************************************

  slider(slick)

**************************************************************************************************** */
jQuery(function($) {

  /* ======================================================================

    メディアクエリの設定

  ====================================================================== */
  var _mql = window.matchMedia('screen and (max-width: 767px)');
  var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
  var _windowWidth = $(window).width();

  /* ======================================================================

    トップページのメインビジュアル

  ====================================================================== */
  if ($('#js-home-kv').length) {

    /* 変数・準備
    ---------------------------------------------------------------------- */
    var $kv = $('#js-home-kv');
    var $kvCont = $kv.children('.s-home-kv__list');
    var $kvContItem = $kv.find('.s-home-kv__item');
    var $kvUi = $kv.children('.s-home-kv__ui');
    var $body = $('#js-body');
    var $targetHeight = 0;
    var $itemHeight = 0;
    var $uiHeight = 0;
    var $clientWidth = document.documentElement.clientWidth;
    var $homeKvFlag = false;
    var ticking = false;

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $kvCont.on('init', function() {
      $kv.addClass('is-active');
      if (_mql.matches) {
        adjustBodySp();
      }
      _mql.addEventListener('change', adjustBody, false);
      window.addEventListener('resize', function() {
        if (!ticking) {
          requestAnimationFrame(function() {
            ticking = false;
            _windowWidth = $(window).width();
            if (_windowWidth < 767) {
              $itemHeight = $kvContItem.outerHeight();
              $uiHeight = $kvUi.outerHeight();
              $targetHeight = $itemHeight + $uiHeight;
              // $targetHeight = ($targetHeight / $clientWidth * 100) + 'vw';
              $body.css('padding-top', $targetHeight);
              // console.log('$itemHeight = ' + $itemHeight);
              // console.log('$uiHeight = ' + $uiHeight);
              // console.log('$targetHeight = ' + $targetHeight);
            }
          });
          ticking = true;
        }
      }, false);
    });
    $kvCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      // variableWidth: true,
      arrows: true,
      appendArrows: $kvUi,
      focusOnSelect: true,
      prevArrow:
        '<div class="s-home-kv__arrow s-home-kv__arrow--prev"><div>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
        '</div></div>',
      nextArrow:
        '<div class="s-home-kv__arrow s-home-kv__arrow--next"><div>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
        '</div></div>',
      dots: true,
      dotsClass: 's-home-kv__nav',
      customPaging: function(slick, index){
        return '<div class="s-home-kv__dot"></div>';
      },
      appendDots: $kvUi,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            // centerMode: false,
            // slidesToShow: 3,
            // slidesToScroll: 3,
            // variableWidth: false,
            // centerPadding: '3rem',
            // focusOnSelect: false,
            // centerMode: false,
            // infinite: false,
            // touchMove: false,
          }
        }
      ]
    });
  }// if ($('#js-home-kv').length) {

  /* 高さ調整
  ---------------------------------------------------------------------- */
  // sp
  function adjustBodySp() {
    $itemHeight = $kvContItem.outerHeight();
    $uiHeight = $kvUi.outerHeight();
    $targetHeight = $itemHeight + $uiHeight;
    $targetHeight = ($targetHeight / $clientWidth * 100) + 'vw';
    $body.css('padding-top', $targetHeight);
  }
  // pc
  function adjustBodyPc() {
    $body.css('padding-top', '');
    // console.log('pcpcpc');
  }
  // toggle
  function adjustBody() {
    console.log("adjustBody");
    if (_mql.matches) {
      // adjustBodySp();
      // setTimeout(adjustBodySp, 500);
    } else {
      adjustBodyPc();
    }
  }

  /* ======================================================================

    トップページのtopics

  ====================================================================== */
  if ($('#js-topics').length) {

    /* 変数・準備
    ---------------------------------------------------------------------- */
    var $topics = $('#js-topics');
    var $topicsCont = $topics.children('.s-topics__list');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $topicsCont.on('init', function() {
      $topics.addClass('is-active');
    });
    $topicsCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      arrows: false,
      focusOnSelect: true,
      dots: true,
      dotsClass: 's-topics__nav',
      customPaging: function(slick, index){
        return '<div class="s-topics__dot"></div>';
      },
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: false,
            // centerPadding: '3rem',
            // focusOnSelect: false,
            // centerMode: false,
            // infinite: false,
            // touchMove: false,
            arrows: true,
            appendArrows: $topics,
            prevArrow:
              '<div class="s-topics__arrow s-topics__arrow--prev"><div>' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
              '</div></div>',
            nextArrow:
              '<div class="s-topics__arrow s-topics__arrow--next"><div>' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
              '</div></div>',
          }
        }
      ]
    });

  }// if ($('#js-topics').length) {

  /* ======================================================================

    シングルページのgallery

  ====================================================================== */
  if ($('#js-gallery').length) {

    /* 変数・準備
    ---------------------------------------------------------------------- */
    var $gallery = $('#js-gallery');
    var $galleryCont = $gallery.children('.p-gallery__list');

    /* スライド初期化時にクラスを追加
    ---------------------------------------------------------------------- */
    // はじめはdisplay:noneしておき、.is-activeが追加されたらdisplay:block
    $galleryCont.on('init', function() {
      $gallery.addClass('is-active');
    });
    $galleryCont.slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      variableWidth: true,
      arrows: false,
      focusOnSelect: true,
      dots: true,
      dotsClass: 'p-gallery__nav',
      customPaging: function(slick, index){
        return '<div class="p-gallery__dot"></div>';
      },
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: false,
            // centerPadding: '3rem',
            // focusOnSelect: false,
            // centerMode: false,
            // infinite: false,
            // touchMove: false,
            arrows: true,
            appendArrows: $gallery,
            prevArrow:
              '<div class="p-gallery__arrow p-gallery__arrow--prev"><div>' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
              '</div></div>',
            nextArrow:
              '<div class="p-gallery__arrow p-gallery__arrow--next"><div>' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 22"><path d="M1.79535,9.5H19.84924L11.4527,2.93922A1.50015,1.50015,0,0,1,13.29987.575L25.12848,9.81764a1.50078,1.50078,0,0,1,0,2.36426L13.29987,21.42457a1.50014,1.50014,0,0,1-1.84717-2.36425L19.84857,12.5H1.79535a1.5,1.5,0,1,1,0-3Z" fill="#333333"/></svg>' +
              '</div></div>',
          }
        }
      ]
    });

  }// if ($('#js-gallery').length) {

});
